export default [
  {
    path: "*",
    component: () => import("@/views/reports/NotFound.vue"),
  },
];
